/* 1119 - header. Mobile drawer plus the two header height variables that
   Horizon's layout script normally writes from its own header component. */
(function () {
  'use strict';

  if (!customElements.get('gtap-header')) {
    customElements.define(
      'gtap-header',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.onClick);
          this.measure();
          this.ro = new ResizeObserver(() => this.measure());
          this.ro.observe(this);
        }
        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          if (this.ro) this.ro.disconnect();
          this.close();
        }
        measure() {
          var h = this.offsetHeight;
          if (!h) return;
          document.body.style.setProperty('--header-height', h + 'px');
          document.body.style.setProperty('--header-group-height', h + 'px');
        }
        get drawer() {
          return this.querySelector('dialog');
        }
        onClick = (e) => {
          if (e.target.closest('[data-gtap-hdr-open]')) {
            e.preventDefault();
            this.open();
            return;
          }
          if (e.target.closest('[data-gtap-hdr-close]')) {
            e.preventDefault();
            this.close();
            return;
          }
          if (e.target === this.drawer) {
            this.close();
            return;
          }
          var cart = e.target.closest('[data-gtap-hdr-cart]');
          if (cart) {
            var drawer = document.querySelector('cart-drawer');
            if (drawer) {
              var fn = drawer.showDialog || drawer.open || drawer.show;
              if (typeof fn === 'function') {
                e.preventDefault();
                fn.call(drawer);
              }
            }
          }
        };
        open() {
          var d = this.drawer;
          if (!d || d.open) return;
          if (typeof d.showModal === 'function') d.showModal();
          else d.setAttribute('open', '');
          var first = d.querySelector('[data-gtap-hdr-close]');
          if (first) first.focus();
        }
        close() {
          var d = this.drawer;
          if (!d || !d.open) return;
          if (typeof d.close === 'function') d.close();
          else d.removeAttribute('open');
        }
      }
    );
  }
})();
